import office from '@/taskpane/officejs/office-wrapper'
import { IObserver } from '@/taskpane/common/observer-pattern'
import broadcastMessageToPortals from '../messages/broadcast-message-to-portals'
import AttachmentInfo from '../models/attachment-info'
import OfficeObservable from './office-observable'

interface ItemAttachmentChangeArgs {
  attachments: AttachmentInfo[]
}

export class AttachmentsObservable extends OfficeObservable<AttachmentInfo[]> {
  public eventHandlerType = () => Office.EventType.AttachmentsChanged
  public get = async () => office.attachments.get()
}

export default class AttachmentsObserver implements IObserver<AttachmentInfo[]> {
  public update(attachments: AttachmentInfo[]): void {
    const args: ItemAttachmentChangeArgs = {
      attachments: attachments,
    }
    broadcastMessageToPortals('ItemAttachmentChange', args)
  }
}
